export default __webpack_public_path__ + "static/media/A9.cc0ec6bf.png";